import { Controller } from '@hotwired/stimulus';

export default class WireTransferDropdownController extends Controller {
  static targets = ['hiddenInput'];

  declare hiddenInputTarget: HTMLSelectElement;

  selectItem(event: Event): void {
    const item = event.currentTarget as HTMLElement;

    this.hiddenInputTarget.value = item.dataset.value || '';
    this.hiddenInputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
